import { render, staticRenderFns } from "./BoletaConsulta.vue?vue&type=template&id=2373c67c&"
import script from "./BoletaConsulta.vue?vue&type=script&lang=js&"
export * from "./BoletaConsulta.vue?vue&type=script&lang=js&"
import style0 from "./BoletaConsulta.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BoletaConsulta.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports